<template>

  <div class="card-background">
      <div class="columns">

          <TournamentMenu :tournament="tournament" :event="event" />

      <div class="column is-four-fifths-desktop is-four-fifths-tablet is-full-printer">

        <div v-if="event" class="tournament-event-draws-container">

            <div class="columns">
                <div class="column is-three-fifths-desktop is-half-tablet is-full-printer">
                    <h2 class="has-text-weight-bold has-text-left is-size-3" style="margin-bottom: 30px;">{{ event.name }}</h2>
                </div>


                <div class="column is-two-fifths-desktop is-half-tablet is-hidden-print">
                    <b-select v-model="stage" class="is-pulled-right">
                        <option value="all">All draws</option>
                        <option value="qualification">Qualification</option>
                        <option value="main-draw">Main draw</option>
                        <option value="consolation">Consolation</option>
                    </b-select>

                    <div class="is-pulled-right is-hidden-print" style="margin-top: 5px; padding-right: 15px; width: auto;">
                        <router-link :to="'/tournaments/' + tournament.id + '/events/' + event.id + '/generator'" class="button is-danger is-small">@</router-link>&nbsp;
                        <router-link :to="'/tournaments/' + tournament.id + '/events/' + event.id + '/edit'" class="button is-warning is-small">Edit</router-link>&nbsp;
                        <router-link :to="'/tournaments/' + tournament.id + '/events/' + event.id + '/draw/add'" class="button is-link is-small">+ Draw</router-link>&nbsp;
                        <router-link :to="'/tournaments/' + tournament.id + '/events/' + event.id + '/entry/add'" class="button is-danger is-small">+ Entry</router-link>
                    </div>
                </div>
            </div>


            <div class="notification is-warning" style="padding-top: 9px; padding-bottom: 7px; vertical-align: middle; margin-top: -35px; margin-bottom: 40px;" v-if="event.scheduleUpdate">
                You have made a modification to one or more events, and some matches need to be rescheduled. &nbsp; &nbsp; <a class="button is-danger is-small" @click="rescheduleMatches(event.scheduleUpdate)">Update</a>
            </div>


            <div>
                <EventDraw :tournament="tournament" :event="event" :draw="draw" v-for="draw in event.draws" v-if="((stage == 'all') || (stage == draw.stage))" />
            </div>




        </div>

        <div v-if="!event">
          <b-loading />
        </div>


      </div>

    </div>
  </div>
</template>

<script>
  import Entry from '../components/Entry.vue';
  import EventDraw from '../components/EventDraw.vue';
  import TournamentMenu from '../components/TournamentMenu.vue';
  import TournamentDataMixin from '../mixins/TournamentDataMixin.js';

export default {
  mixins: [ TournamentDataMixin ],

  data: () => {
    return {
        stage: 'all'
    }
  },
  computed: {
      event: function() {
          let selected = null;
          if (this.tournament && this.tournament.events) {
              selected = this.tournament.events.filter(event => event.id == this.eventId);
              if (selected && selected.length > 0) {
                  selected = selected[0];
              } else {
                  selected = null;
              }
          }

          return selected;
      },
      eventId: function() { return this.$route.params.event; },

    tournaments: function(){ return this.$store.state.tournaments; }
  },

  methods: {

  },

  components: { TournamentMenu, Entry, EventDraw },
  name: 'tournament-event-draws'
}
</script>



<style>

</style>
